import { App } from "./App.tsx"
import { Chat } from "./components/Chat.tsx"
import { chatEvents } from "./constants.ts"
import "./style.css"
import { createRoot } from "react-dom/client"

const isDev = import.meta.env.DEV
const isPreview = import.meta.env.PREVIEW_BUILD || import.meta.env.MODE === "preview"

function initChat(options?: { containerId?: string }) {
  let root: ReturnType<typeof createRoot> | null = null

  const containerId = options?.containerId || "chat-bot-root"
  let container = document.getElementById(containerId)

  if (!container) {
    container = document.createElement("div")
    container.id = containerId
    document.body.appendChild(container)
  }

  if (!root) {
    root = createRoot(container)
    root.render(isDev || isPreview ? <App /> : <Chat />)
  }

  return root
}

if (isDev || isPreview) {
  document.addEventListener("DOMContentLoaded", () => {
    initChat({ containerId: "root" })
  })
}

export default {
  init: initChat,
  events: chatEvents,
}
